import ModelApiService from "../utils/modelApiService";

class ContractIterationApiService extends ModelApiService {
  constructor() {
    super("/contract-iterations/", "période");
  }

}

export default ContractIterationApiService;